var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSidebarApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08812 0.00292969C2.31585 0.00292969 1.57521 0.297805 1.02913 0.822688C0.483053 1.34757 0.17627 2.05946 0.17627 2.80176V8.39941C0.17627 9.14171 0.483053 9.8536 1.02913 10.3785C1.57521 10.9034 2.31585 11.1982 3.08812 11.1982H8.91183C9.6841 11.1982 10.4247 10.9034 10.9708 10.3785C11.5169 9.8536 11.8237 9.14171 11.8237 8.39941V2.80176C11.8237 2.05946 11.5169 1.34757 10.9708 0.822688C10.4247 0.297805 9.6841 0.00292969 8.91183 0.00292969H3.08812ZM0.661579 13.0641C0.532867 13.0641 0.409426 13.1133 0.318413 13.2008C0.2274 13.2882 0.17627 13.4069 0.17627 13.5306C0.17627 13.6543 0.2274 13.773 0.318413 13.8604C0.409426 13.9479 0.532867 13.9971 0.661579 13.9971H11.3384C11.4671 13.9971 11.5905 13.9479 11.6815 13.8604C11.7726 13.773 11.8237 13.6543 11.8237 13.5306C11.8237 13.4069 11.7726 13.2882 11.6815 13.2008C11.5905 13.1133 11.4671 13.0641 11.3384 13.0641H0.661579Z",
    fill: "#A8ADBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarApp);
export default __webpack_public_path__ + "static/media/ic-sidebar-app.7ee23c1e03527a993bb92bb9be7f600e.svg";
export { ForwardRef as ReactComponent };